define('AwaLabs.CategoriesSearch', [
    'SiteSearch.CategorySearch.View',
    'Backbone',
    'Session',
    'ItemsSearcher.View',
    'ItemsSearcher.Utils',
    'SiteSearch.View',
    'SC.Configuration',
    'jQuery',
    'Utils',
    'underscore'
], function AwaLabsCategoriesSearch(
    CategorySearchView,
    Backbone,
    Session,
    ItemsSearcherView,
    ItemsSearcherUtils,
    SiteSearchView,
    Configuration,
    jQuery,
    Utils,
    _
) {
    'use strict';

    SiteSearchView.prototype.childViews = SiteSearchView.prototype.childViews || {};
    SiteSearchView.prototype.childViews.CategorySearch = function categorySearchView() {
        return new CategorySearchView({
            application: this.application
        });
    };
    SiteSearchView.prototype.executeSearch = function executeSearch(keywords) {
        var searchUrl = Utils.getPathFromObject(Configuration, 'defaultSearchUrl');
        var delimiters = Utils.getPathFromObject(Configuration, 'facetDelimiters');
        var keywordsDelimited = delimiters
            ? delimiters.betweenFacetsAndOptions + 'keywords' + delimiters.betweenOptionNameAndValue
            : '?keywords=';

        var category = this.application.getCurrentCategory(true);
        if (category) {
            searchUrl = category.get('fullurl');
        }
        // If we are not in Shopping we have to redirect to it
        if (Utils.getPathFromObject(Configuration, 'currentTouchpoint') !== 'home') {
            // we called this using fragment instead of # because bridged domain
            window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
                fragment: searchUrl + keywordsDelimited + keywords
            });
        } else {
            // We navigate to the default search url passing the keywords
            Backbone.history.navigate(
                searchUrl + keywordsDelimited + keywords + this.getCurrentSearchOptions(),
                { trigger: true }
            );
        }
    };


    _.extend(ItemsSearcherView.prototype, {
        /* note: this is superseeded by searchspring */
        loadSuggestionItemsSource: function loadSuggestionItemsSource(query, callback, callbackAsync) {
            var plp = this.parentView.application.getComponent('PLP');
            var self = this;
            var data;
            var currentCategory = plp.current_view && plp.current_view.model && plp.current_view.model.get('category');

            self.options.ajaxDone = false;
            self.options.results = {};
            self.options.query = ItemsSearcherUtils.formatKeywords(query);
            this.collection = new this.options.collection([], this.options.collectionOptions);

            if (self.options.query.length >= self.options.minLength) {
                self.options.labels = ['see-all-' + self.options.query];
                callback(self.options.labels);
            }

            data = {
                q: jQuery.trim(self.options.query),
                sort: self.options.sort,
                limit: self.options.limit,
                offset: 0
            };
            if (currentCategory && jQuery('.site-search-category-checkbox:checked').length) {
                data.commercecategoryurl = currentCategory.get('fullurl');
            }
            self.collection
                .fetch({
                    data: data,
                    killerId: _.uniqueId('ajax_killer_')
                },
                {
                    silent: true
                }).done(function onDone() {
                    self.collection =
                        self.postItemsSuggestionObtained.executeAll(self.collection, self.options) ||
                        self.collection;

                    self.options.ajaxDone = true;
                    self.options.labels = self.options.showSeeAll
                        ? ['see-all-' + self.options.query].concat(self.getItemIds(self.collection))
                        : self.getItemIds(self.collection);

                    if (!self.options.labels.length) {
                        self.options.labels = ['see-all-' + self.options.query];
                    }

                    callbackAsync(self.options.labels);

                    self.selectFirstIfRequire();
                }
            );
        }
    });

    return {
        mountToApp: function mountToApp(application) {
            application.getCurrentCategory = function getCurrentCategory(verifyCheckbox) {
                var checkbox;
                var currentView = application.getLayout().currentView;
                var currentCategory = currentView &&
                    currentView.model &&
                    currentView.model.get('category');

                if (verifyCheckbox) {
                    checkbox = jQuery('.site-search-category-checkbox:checked').length;
                }

                if (currentCategory && (!verifyCheckbox || (verifyCheckbox && checkbox))) {
                    return currentCategory;
                }

                return false;
            };
        }
    };
});
